import { QueryClient } from '@tanstack/react-query'

const QUERY_CLIENT_KEY = '__EVIRMA_QUERY_CLIENT__'

export function getQueryClient() {
  if (typeof window === 'undefined') {
    return new QueryClient()
  }
  const win = window as Window & { [QUERY_CLIENT_KEY]?: QueryClient }
  if (!win[QUERY_CLIENT_KEY]) {
    win[QUERY_CLIENT_KEY] = new QueryClient()
  }
  return win[QUERY_CLIENT_KEY]
}

export const queryClient = getQueryClient()
